import * as uuid from 'uuid';
var uuidv4 = uuid.v4;
var CuratedPackageManager = /** @class */ (function () {
    function CuratedPackageManager() {
        this._CuratedPackageIdStateListeners = {};
    }
    CuratedPackageManager.getInstance = function () {
        if (CuratedPackageManager.instance) {
            return CuratedPackageManager.instance;
        }
        CuratedPackageManager.instance = new CuratedPackageManager();
        return CuratedPackageManager.getInstance();
    };
    CuratedPackageManager.prototype.getMostRecentCuratedPackage = function (sound) {
        if (CuratedPackageManager.cache[sound.id]) {
            if (new Date(sound.updated_at) < new Date(CuratedPackageManager.cache[sound.id].updated_at)) {
                return CuratedPackageManager.cache[sound.id];
            }
        }
        return sound;
    };
    CuratedPackageManager.prototype.updateCuratedPackage = function (allbum) {
        CuratedPackageManager.cache[allbum.id] = allbum;
        this.callCuratedPackageStateListeners(allbum);
    };
    CuratedPackageManager.prototype.addCuratedPackageStateListener = function (CuratedPackage, listener) {
        var id = uuidv4();
        var listenersObj = {};
        listenersObj[id] = listener;
        this._CuratedPackageIdStateListeners[CuratedPackage.id] = Object.assign({}, (this._CuratedPackageIdStateListeners[CuratedPackage.id] || {}), listenersObj);
        if (CuratedPackageManager.cache[CuratedPackage.id]) {
            if (new Date(CuratedPackage.updated_at) < new Date(CuratedPackageManager.cache[CuratedPackage.id].updated_at)) {
                listener(CuratedPackageManager.cache[CuratedPackage.id]);
            }
            else {
                CuratedPackageManager.cache[CuratedPackage.id] = CuratedPackage;
            }
        }
        else {
            CuratedPackageManager.cache[CuratedPackage.id] = CuratedPackage;
        }
        return id;
    };
    CuratedPackageManager.prototype.removeCuratedPackageStateListener = function (CuratedPackage, id) {
        this._CuratedPackageIdStateListeners[CuratedPackage.id] && delete this._CuratedPackageIdStateListeners[CuratedPackage.id][id];
    };
    CuratedPackageManager.prototype.callCuratedPackageStateListeners = function (CuratedPackage) {
        var _this = this;
        Object.keys(this._CuratedPackageIdStateListeners[CuratedPackage.id] || {}).map(function (key) { return (_this._CuratedPackageIdStateListeners[CuratedPackage.id] || {})[key]; }).forEach(function (data) {
            var cb = data;
            cb(CuratedPackage);
        });
    };
    CuratedPackageManager.cache = {};
    return CuratedPackageManager;
}());
export default CuratedPackageManager;
//# sourceMappingURL=curatedpackagemanager.js.map